export const modalTypes = {
  SELECT_CARD_MODAL: 'selectCardModal',
  TERMS_MODAL: 'termsModal',
};
